<!-- ----------------Account--Manager--Page--Start------------------------- -->
<div class="container-scroller">
    <div class="main-panel">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-md-12 mb-3">
                    <h3 class="font-weight-bold heading"><b>Firewall Server</b><button type="button"
                            class="comman-btn1 btn-primary me-2 float-end" (click)="addUpdateServer('')">+
                            Server</button></h3>
                </div>
            </div>
            <!-- ---------table-section--------- -->
            <div class="row table-section pe-0">
                <div class="col-md-12 grid-margin stretch-card pe-0">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <div class="  records">{{updatePaginationText}} </div>
                            </div>
                            <div *ngIf="!isServerAvailable" class="text-center">
                                <h4>There is no {{selectedStatusType | titlecase}} Server.</h4>

                            </div>
                            <div class="table-responsive" *ngIf="isServerAvailable">
                                <table class="table table-striped table-borderless table-sm">
                                    <thead class="roundedTable thead-header">
                                        <tr>
                                            <th scope="col" (click)="sortingServer('id')">Name <i
                                                    class="bi bi-arrow-down-up"></i>
                                            </th>
                                            <th scope="col">IP Address</th>
                                            <th scope="col">Public IP Address</th>
                                            <th scope="col">RAM</th>
                                            <th scope="col">CPU</th>
                                            <th scope="col">Storage</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let server of servers | paginate : config">
                                            <td class="productNameCursor" (click)="addUpdateServer(server._id)">
                                                <span [ngbTooltip]="server?.description | titlecase" placement="top">
                                                    {{server?.name|titlecase}}</span>
                                            </td>
                                           
                                            <td>{{server?.ip}}</td>
                                            <td>{{server?.publicIp}}</td>
                                            <td>{{server?.ram}}</td>
                                            <td>{{server?.cpu}}</td>
                                            <td>{{server?.storage}}</td>
                                            <td class="text-center">
                                                <i class="bi bi-pencil-fill text-primary productNameCursor me-3 fs-6 "
                                                    ngbTooltip="Update Server" placement="top"
                                                    (click)="addUpdateServer(server._id)"></i>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mt-4 float-end me-4" *ngIf="isServerAvailable">
                                <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- -----end-------- -->
        </div>
    </div>
</div>